import { useContextSelector } from 'use-context-selector';
import { DndOpsContext } from '../contexts/DndOpsContext';

/**
 * returns the asset id being dragged onto the current asset only in the case of
 * a valid version stacking operation
 * */
export const useDraggingIds = ({ skip }: { skip?: boolean } = {}) => {
  return useContextSelector(DndOpsContext, ({ active, draggingIds }) => {
    return skip ? { draggingIds: emptySet } : { active, draggingIds };
  });
};

const emptySet = new Set<string>();
